import {ApiRequestType, onRequestFailure, onRequestSuccess} from "../middlewares/apiMiddleware";

const SLICE = 'auth';

export interface AuthAPIRegisterDataType {
  email: string,
  password: string,
  password_confirmation: string,
}

export interface AuthAPIConfirmDataType {
  email_verification_code: string,
}

export interface AuthAPILoginDataType {
  email: string,
  password: string,
}

export interface AuthAPIRecoveryDataType {
  email: string,
}

export interface AuthAPIResetDataType {
  email_verification_code: string,
  password: string,
}

export interface AuthAPILogoutDataType {
  // no args...
}

export const AuthAPI = {

  register: function (data: AuthAPIRegisterDataType, onRequestSuccess?: onRequestSuccess, onRequestFailure?: onRequestFailure): ApiRequestType {
    return {
      type: 'API',
      url: `/auth/register`,
      method: 'POST',
      data: data,
      slice: SLICE,
      action: 'register',
      onRequestSuccess: onRequestSuccess,
      onRequestFailure: onRequestFailure,
    };
  },

  confirm: function (data: AuthAPIConfirmDataType, onRequestSuccess?: onRequestSuccess, onRequestFailure?: onRequestFailure): ApiRequestType {
    return {
      type: 'API',
      url: `/auth/confirm`,
      method: 'POST',
      data: data,
      slice: SLICE,
      action: 'confirm',
      onRequestSuccess: onRequestSuccess,
      onRequestFailure: onRequestFailure,
    };
  },

  login: function (data: AuthAPILoginDataType, onRequestSuccess?: onRequestSuccess, onRequestFailure?: onRequestFailure): ApiRequestType {
    return {
      type: 'API',
      url: `/auth/login`,
      method: 'POST',
      data: data,
      slice: SLICE,
      action: 'login',
      onRequestSuccess: onRequestSuccess,
      onRequestFailure: onRequestFailure,
    };
  },

  recovery: function (data: AuthAPIRecoveryDataType, onRequestSuccess?: onRequestSuccess, onRequestFailure?: onRequestFailure): ApiRequestType {
    return {
      type: 'API',
      url: `/auth/recovery`,
      method: 'POST',
      data: data,
      slice: SLICE,
      action: 'recovery',
      onRequestSuccess: onRequestSuccess,
      onRequestFailure: onRequestFailure,
    };
  },

  reset: function (data: AuthAPIResetDataType, onRequestSuccess?: onRequestSuccess, onRequestFailure?: onRequestFailure): ApiRequestType {
    return {
      type: 'API',
      url: `/auth/reset`,
      method: 'POST',
      data: data,
      slice: SLICE,
      action: 'reset',
      onRequestSuccess: onRequestSuccess,
      onRequestFailure: onRequestFailure,
    };
  },

  logout: function (data: AuthAPILogoutDataType, onRequestSuccess?: onRequestSuccess, onRequestFailure?: onRequestFailure): ApiRequestType {
    return {
      type: 'API',
      url: `/auth/logout`,
      method: 'POST',
      data: data,
      slice: SLICE,
      action: 'logout',
      onRequestSuccess: onRequestSuccess,
      onRequestFailure: onRequestFailure,
    };
  }
}
